export const combineText = (text1, text2: string[]) => {
  let text = text1 || '';
  for (let newText of text2) {
    text = text.replace('##', newText);
  }
  return text;
};
